import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { setClear, setMaskAct, setMemoAct, setMode, setUndo } from '../../../store/ToolSlice';
import { Button } from '../../_atoms/Button';
import { Heading } from '../../_atoms/Heading';

const Div = styled.div`
  padding: 10px 0;
  margin-bottom: 15px;
  background-color: #fff;
  text-align: center;
  display: grid;
  grid-template-columns: repeat(2, 50px);
  grid-template-rows: repeat(5,auto);
  grid-column-gap: 10px;
  justify-content: center;
`;

export const ToolBox = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const onChangeTool = (type) => {
    dispatch(setMode(type));
  };
   
  return (
    <Div>
      <Heading level={1} type="tool">Tool Box</Heading>
      <Button type="tool" name="select" className={(state.tool.tool_act && state.tool.mode === 'S') && 'act'} onClick={() => onChangeTool('S')}/>
      <Button type="tool" name="memo" className={state.tool.memo_act && 'act'} onClick={() => dispatch(setMemoAct(!state.tool.memo_act))}/>
      <Button type="tool" name="pen" className={(state.tool.tool_act && state.tool.mode === 'P') && 'act'} onClick={() => onChangeTool('P')}/>
      <Button type="tool" name="color" className={(state.tool.tool_act && state.tool.mode === 'R') && 'act'} onClick={() => onChangeTool('R')}/>
      <Button type="tool" name="eraser" onClick={() => dispatch(setUndo(true))}/>
      <Button type="tool" name="reset" onClick={() => dispatch(setClear(true))}/>
      <Button type="tool" name="telescope" className={state.tool.mask_act && 'act'} onClick={() => dispatch(setMaskAct(!state.tool.mask_act))}/>
    </Div>
  );
};